import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';

export const UnarchiveDesignForm = ({ design, setDesigns }) => {
    const { token, base_url } = useAppContext();

    return (
        <ConfirmDialog
            trigger={
                <button className="btn btn-action btn-secondary" title="Unarchive Design">
                    <FontAwesomeIcon icon={faUndo} />
                    <span>Unarchive</span>
                </button>
            }
            title="Unarchive Design"
            message="Are you sure you want to unarchive this design?"
            entityLabel={`Design: ${design?.design_name}`}
            detail="This action will restore the design to your active designs list."
            confirmLabel="Unarchive Design"
            submittingLabel="Unarchiving..."
            successMessage="Design unarchived successfully!"
            errorMessages={{
                notFound: 'Design not found',
                client: 'Invalid design data. Please check your input.',
                default: 'Failed to unarchive design. Please try again.',
            }}
            onConfirm={async () => {
                const updated_design = await updateData(
                    token,
                    `${base_url}/apis/designs/${design.id}`,
                    { is_archived: false }
                );

                if (!updated_design.design) return false;

                setDesigns((prevDesigns) =>
                    prevDesigns.filter((d) => d.id !== design.id)
                );
            }}
        />
    );
};
